import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { glyphPaths } from '../icons/icon-paths';

const ABTEST_IMAGES = [
  'a.png',
  'b.png',
  'c.png',
  'd.png',
  'e.png',
  'f.png',
];

export default function ImageCrossfade() {
  const productImageRef = useRef();
  const productImageBackRef = useRef();
  const imageIndexRef = useRef(0);
  const isTransitioningRef = useRef(false);
  const intervalRef = useRef();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
    // Set initial images
    if (productImageRef.current) {
      // Load base images
      productImageRef.current.src = `/img/abtest/${ABTEST_IMAGES[0]}`;
      gsap.set(productImageRef.current, { opacity: 1 });
    }
    if (productImageBackRef.current) {
      // Load base images
      productImageBackRef.current.src = `/img/abtest/${ABTEST_IMAGES[1]}`;
      gsap.set(productImageBackRef.current, { opacity: 0 });
    }

    function transitionAbTestImage() {
      if (isTransitioningRef.current) return;
      
      isTransitioningRef.current = true;
      imageIndexRef.current = (imageIndexRef.current + 1) % ABTEST_IMAGES.length;
      setCurrentIndex(imageIndexRef.current);
      // Load base images
      const imageName = ABTEST_IMAGES[imageIndexRef.current];
      const nextImage = `/img/abtest/${imageName}`;
      
      if (productImageRef.current && productImageBackRef.current) {
        const preloadImage = new window.Image();
        preloadImage.onload = () => {
          if (!productImageBackRef.current || !productImageRef.current) {
            isTransitioningRef.current = false;
                return;
            }

          // Set the background image source to the new image
          productImageBackRef.current.src = nextImage;
          
          // Wait a frame to ensure the image is loaded, then fade in background
          requestAnimationFrame(() => {
            // First, fade in the background image completely
            gsap.to(productImageBackRef.current, {
              opacity: 1,
              duration: 0.5,
              ease: 'power2.inOut',
              onComplete: () => {
                // Only after background is fully visible, fade out the foreground
                gsap.to(productImageRef.current, {
                  opacity: 0,
                  duration: 0.5,
                  ease: 'power2.inOut',
                  onComplete: () => {
                    if (!productImageRef.current || !productImageBackRef.current) {
                      isTransitioningRef.current = false;
                        return;
                    }

                    // Now swap the images: background becomes foreground
                    productImageRef.current.src = nextImage;
                    
                    // Reset opacities
                    gsap.set(productImageRef.current, { opacity: 1 });
                    gsap.set(productImageBackRef.current, { opacity: 0 });
                    
                    // Reset transition flag
                    isTransitioningRef.current = false;
                  }
                });
                        }
            });
                });
        };

        preloadImage.onerror = () => {
          isTransitioningRef.current = false;
        };
        
        // Start loading the image
        preloadImage.src = nextImage;
      }
    }

    // Start the interval after a short delay
    const startInterval = () => {
      intervalRef.current = setInterval(transitionAbTestImage, 800);
    };
    
    setTimeout(startInterval, 1000); // Start after 1 second

        return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
            }
        };
    }, []);

    return (
        <div
      className="rounded"
                  style={{ 
                width: '100%', 
                maxWidth: '256px',
                aspectRatio: '1 / 1',
        position: 'relative',
        margin: '0',
                height: 'auto',
        textAlign: 'left',
        overflow: 'hidden',
      }}
        >
      {/* Background image layer (for crossfade) */}
      <img
        ref={productImageBackRef}
        src="/img/abtest/b.png"
        alt="next"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
          opacity: 0,
          zIndex: 1,
                    objectFit: 'cover',
          objectPosition: 'center top',
          borderRadius: 'inherit',
                }}
            />
      {/* Foreground image layer (currently visible) */}
      <img
        ref={productImageRef}
        src="/img/abtest/a.png"
        alt="current"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
          opacity: 1,
          zIndex: 2,
                    objectFit: 'cover',
          objectPosition: 'center top',
          borderRadius: 'inherit',
                }}
            />
            
            {/* VAR and IDX overlays */}
            <div style={{ position: 'absolute', bottom: 10, left: 12, zIndex: 100, display: 'flex', flexDirection: 'column', gap: 0 }}>
                <span
                    style={{
                        fontFamily: 'var(--font-b)',
                        fontSize: '11px',
                        color: 'var(--c0)',
                        letterSpacing: '0.08em',
                        fontWeight: 500,
                        lineHeight: 1.1,
                        userSelect: 'none',
                        pointerEvents: 'none',
                    }}
                >
                    var_abtest
                </span>
                <span
                    style={{
                        fontFamily: 'var(--font-b)',
                        fontSize: '11px',
                        color: 'var(--c0)',
                        letterSpacing: '0.08em',
                        fontWeight: 500,
                        lineHeight: 1.1,
                        userSelect: 'none',
                        pointerEvents: 'none',
                    }}
                >
                    idx_{String.fromCharCode(97 + currentIndex)}
                </span>
            </div>

            {/* SVG glyph in top right */}
            <svg
                width={12}
                height={12}
                viewBox="0 0 24 24"
                style={{
                    position: 'absolute',
                    top: 10,
                    right: 12,
                    zIndex: 100,
                    display: 'block',
                    pointerEvents: 'none',
                }}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
        <path d={glyphPaths[`g0${(currentIndex % 6) + 1}`]?.match(/d="([^"]+)"/)?.[1] || 'M.71,23.37V.79H23.29V23.37Zm7.52-7.52h7.54V8.31H8.23Z'} fill="var(--c0)" />
            </svg>
        </div>
    );
} 